import { render, staticRenderFns } from "./SearchOfCase.vue?vue&type=template&id=34aded38&scoped=true&"
import script from "./SearchOfCase.vue?vue&type=script&lang=js&"
export * from "./SearchOfCase.vue?vue&type=script&lang=js&"
import style0 from "./SearchOfCase.vue?vue&type=style&index=0&id=34aded38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aded38",
  null
  
)

export default component.exports